// import { useDispatch, useSelector } from "react-redux";
// import AdminContainer from "./admin";
// import UserContainer from "./user";
// import { useAppSelector } from "hooks/store";
// import { useEffect } from "react";

// const Container = () => {
//   const dispatch = useDispatch();
//   const { settings } = useAppSelector(({ main }) => main);

//   const convertNumberToHex = (num: number): string =>
//     `#${num.toString(16).padStart(6, "0")}`;

//   const convertHexToRgb = (hex: string) => {
//     const parsedHex = hex.replace("#", "");
//     const r = parseInt(parsedHex.slice(0, 2), 16);
//     const g = parseInt(parsedHex.slice(2, 4), 16);
//     const b = parseInt(parsedHex.slice(4, 6), 16);
//     return { r, g, b };
//   };
//   const isValidHex = (hex: string): boolean => /^#?[0-9A-F]{6}$/i.test(hex);

//   const handleThemeColorChangeComplete = (color: number) => {
//     const hexColor = convertNumberToHex(color);
//     if (isValidHex(hexColor)) {
//       const rgbColor = convertHexToRgb(hexColor);
//       const { r, g, b } = rgbColor;
//       const rgbString = `${r} ${g} ${b}`;
//       document.documentElement.style.setProperty("--color-primary", rgbString);
//       // dispatch(updateThemeColor(rgbString));
//     } else {
//       console.warn("Invalid theme color value, unable to set color");
//     }
//   };
// const handlePriceColorChangeComplete = (color: number) => {
//   const hexColor = convertNumberToHex(color);
//   if (isValidHex(hexColor)) {
//     const rgbColor = convertHexToRgb(hexColor);
//     const { r, g, b } = rgbColor;
//     const rgbString = `${r} ${g} ${b}`;
//     document.documentElement.style.setProperty("--color-pricetextcolor", rgbString);
//     // dispatch(updateThemeColor(rgbString));
//   } else {
//     console.warn("Invalid price color value, unable to set color");
//   }
// };
// useEffect(() => {
//   if (settings) {
//     if (settings.itemPriceColor) {
//       handlePriceColorChangeComplete(settings.itemPriceColor);
//     }

//     if (settings.themeColor) {
//       handleThemeColorChangeComplete(settings.themeColor);
//     }
//   }
// }, [settings]);
//   if (window.location.pathname.includes("admin")) {
//     return <AdminContainer />;
//   }
//   return <UserContainer />;
// };

// export default Container;

import AdminContainer from "./admin";
import UserContainer from "./user";
import { useAppDispatch, useAppSelector } from "hooks/store";
import { useEffect, useState } from "react";
import { ThemeProvider } from "@mui/material";
import { createDynamicTheme } from "../themes/mui";
import { resetStates, setGestData } from "store/slices/main.slice";
import Footer from "components/common/Footer";

export const convertNumberToHex = (num: number): string => {
  if (num === 0) return "#000000";
  return `#${num.toString(16).padStart(6, "0")}`;
};

const Container = () => {
  const { settings, userData } = useAppSelector(({ main }) => main);
  const dispatch = useAppDispatch();

  const convertHexToRgba = (hex: string) => {
    const parsedHex = hex.replace("#", "");
    const r = parseInt(parsedHex.slice(0, 2), 16);
    const g = parseInt(parsedHex.slice(2, 4), 16);
    const b = parseInt(parsedHex.slice(4, 6), 16);

    return { r, g, b };
  };

  const isValidHex = (hex: string): boolean => /^#?[0-9A-F]{6}$/i.test(hex);

  const [theme, setTheme] = useState(
    createDynamicTheme("rgb(0,0,0)", "rgb(0,0,0)", "rgb(0,0,0)"), // Default colors
  );

  const handleColorChange = (color: number, cssVariable: string) => {
    const hexColor = convertNumberToHex(color);
    if (isValidHex(hexColor)) {
      const { r, g, b } = convertHexToRgba(hexColor);
      const rgbString = `${r} ${g} ${b}`;
      document.documentElement.style.setProperty(cssVariable, rgbString);
    } else {
      console.warn(
        `Invalid color value for ${cssVariable}, unable to set color`,
      );
    }
  };

  // useEffect(() => {
  //   if (settings) {
  //     if (settings.itemPriceColor) {
  //       handlePriceColorChangeComplete(settings.itemPriceColor);
  //     }

  //     if (settings.themeColor) {
  //       handleThemeColorChangeComplete(settings.themeColor);
  //     }
  //   }
  // }, [settings]);

  useEffect(() => {
    if (settings) {
      // Update theme color
      if (settings.themeColor !== undefined) {
        handleColorChange(settings.themeColor, "--color-primary");
      }

      // Update item price text color
      if (settings.itemPriceColor !== undefined) {
        handleColorChange(settings.itemPriceColor, "--color-pricetextcolor");
      }

      // Update item color
      if (settings.itemColor !== undefined) {
        handleColorChange(settings.itemColor, "--color-itemColor");
      }

      // Update department color
      if (settings.deptColor !== undefined) {
        handleColorChange(settings.deptColor, "--color-deptColor");
      }

      // Update selected theme text color
      if (settings.themeSelColor !== undefined) {
        handleColorChange(settings.themeSelColor, "--color-themeSelColor");
      }

      // Update selected theme text color
      if (settings.itemPriceBgColor !== undefined) {
        handleColorChange(settings.itemPriceBgColor, "--color-pricebgcolor");
      }

      // Update selected theme text color
      if (settings.headerColor !== undefined) {
        handleColorChange(settings.headerColor, "--color-headerbgcolor");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [settings]);

  useEffect(() => {
    if (settings) {
      const primaryColor = settings.themeColor
        ? `rgb(${convertHexToRgba(convertNumberToHex(settings.themeColor)).r}, 
                ${convertHexToRgba(convertNumberToHex(settings.themeColor)).g}, 
                ${convertHexToRgba(convertNumberToHex(settings.themeColor)).b})`
        : "rgb(0,0,0)";

      const textColor = settings.itemPriceColor
        ? `rgb(${
            convertHexToRgba(convertNumberToHex(settings.itemPriceColor)).r
          }, 
                ${
                  convertHexToRgba(convertNumberToHex(settings.itemPriceColor))
                    .g
                }, 
                ${
                  convertHexToRgba(convertNumberToHex(settings.itemPriceColor))
                    .b
                })`
        : "rgb(0,0,0)";

      const themeSelColor = settings.themeSelColor
        ? `rgb(${
            convertHexToRgba(convertNumberToHex(settings.themeSelColor)).r
          }, 
                ${
                  convertHexToRgba(convertNumberToHex(settings.themeSelColor)).g
                }, 
                ${
                  convertHexToRgba(convertNumberToHex(settings.themeSelColor)).b
                })`
        : "rgb(0,0,0)";

      setTheme(createDynamicTheme(primaryColor, textColor, themeSelColor));
    }
  }, [settings]);

  // useEffect(() => {
  //   if (settings) {
  //     const primaryColor = settings.themeColor
  //       ? convertHexToRgb(convertNumberToHex(settings.themeColor))
  //       : "rgb(0,0,0)";
  //     const textColor = settings.itemPriceColor
  //       ? convertHexToRgb(convertNumberToHex(settings.itemPriceColor))
  //       : "rgb(0,0,0)";

  //     setTheme(createDynamicTheme(primaryColor, textColor));
  //   }
  // }, [settings]);

  useEffect(() => {
    const handleBrowserClose = () => {
      if (!!settings?.clearCartOnBrowerExit && !userData) {
        dispatch(resetStates());
      }
      dispatch(setGestData(undefined));
    };

    const refreshThePage = () => {
      if (!!settings?.clearCartOnBrowerExit && !userData) {
        dispatch(resetStates());
      }
    };

    window.addEventListener("unload", handleBrowserClose);
    window.addEventListener("beforeunload", refreshThePage);

    return () => {
      window.removeEventListener("unload", handleBrowserClose);
      window.removeEventListener("beforeunload", refreshThePage);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [settings, userData]);

  return (
    <ThemeProvider theme={theme}>
      <>
        {window.location.pathname.includes("admin") ? (
          <div className="max-w-screen-3xl 3xl:mx-auto">
            <AdminContainer />
          </div>
        ) : (
          <div className="flex flex-col">
            <UserContainer />
            <Footer />
          </div>
        )}
      </>
    </ThemeProvider>
  );
};

export default Container;
